import { Injectable } from '@angular/core';
import { UserModalComponent } from 'src/app/auth/private/components/user/user-details/user-modal/user-modal.component';
import { ServiceModel } from 'src/app/shared/models/service.model';
import { UserModel } from 'src/app/shared/models/user.model';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserServicesService {
  public servicesIconsPath: string;
  public servicesList: Array<ServiceModel>;
  public internalServices: Array<ServiceModel>;
  public publicServices: Array<ServiceModel>;
  // public currentService: {name: string, type: 'internal' | 'public'};

  constructor(private authService: AuthService) {
    this.servicesIconsPath = '/assets/img/icons/workspace-services/';
    this.servicesList = [];
    this.internalServices = [];
    this.publicServices = [];
  }

  public getUserServices(servicesType?: 'internal' | 'public'): Promise<Array<ServiceModel>> {
    // const user = this.authService.getCurrentUser();
    return new Promise((resolve, reject) => {
      this.authService.getUserLogged().subscribe({
        next: (user: UserModel) => {
          let services: Array<ServiceModel>;
          if (user) {
            if (servicesType && servicesType === 'internal') {
              this.internalServices = user.client.services.filter(service => service.internal === true);
              this.internalServices = this.internalServices.map(service => JSON.parse(JSON.stringify(service)));
              services = this.internalServices;
            } else if (servicesType && servicesType === 'public') {
              this.publicServices = user.client.services.filter(service => service.public_service === true);
              this.publicServices = this.publicServices.map(service => JSON.parse(JSON.stringify(service)));
              services = this.publicServices;
            } else {
              this.servicesList = user.client.services;
              services = this.servicesList;
            }
          }
          resolve(services);
        }, // Resolve with the first emitted value
        error: err => reject(err), // Reject if there is an error
        complete: () => {
          // Optionally handle completion if needed, though resolve will be called on the first emission
        },
      });
    });
    // this.authService.getUserLogged().subscribe((u: UserModel) => {
    //   user = u;
    //   console.log('hola observable', u)
    // });
    // console.log('hola ususer service');
    // if (servicesType && servicesType === 'internal') {
    //   this.internalServices = user.client.services.filter(service => service.internal === true);
    //   this.internalServices = this.internalServices.map(service => JSON.parse(JSON.stringify(service)));
    //   return this.internalServices;
    // } else if (servicesType && servicesType === 'public') {
    //   this.publicServices = user.client.services.filter(service => service.public_service === true);
    //   this.publicServices = this.publicServices.map(service => JSON.parse(JSON.stringify(service)));
    //   return this.publicServices;
    // } else {
    //   this.servicesList = user.client.services;
    //   return this.servicesList;
    // }
  }

  public routeToServicePath(route) {
    return '/' + route.split('/')[1] + '/' + route.split('/')[2];
  }
}
